const MapElementModel = {
  latitude: '',
  longitude: '',
  zoom: 16,
  address: { pl: '' },
};

export default MapElementModel;
